<template>
  <div class="text-container md:md-text-container">
    <div class="grid grid-cols-1 md:grid-cols-10 gap-5">
      <div class="md:col-span-8">
        <Heading text="Congratulations!"/>
      </div>
      <div class="md:col-span-8">
        You have successfully taken a Psyche-Selfie of your
      </div>
      <div class="md:col-span-8 theme">
        Happy Place
      </div>
      <div class="md:col-span-8">
        Please wait a moment whilst the programme saves your snapshot to the gallery...
      </div>
    </div>
    <audio ref="aud" src="@/assets/audio/congratulations.mp3" />
  </div>
</template>

<script>
import Heading from '@/components/Heading.vue';

export default {
  name: 'Congratulations',
  components: {
    Heading,
  },
  methods: {
    nextPage() {
      this.$store.commit('setView', 'Sharing');
    },
  },
  mounted() {
    this.$refs.aud.onended = this.nextPage;
    this.$refs.aud.play();
    /*
      nextPage should be trigged in 13 seconds (length of audio clip),
      but if it's been stopped will never end, so this triggers nextPage
      in case it's been stopped
    */
    setTimeout(() => {
      this.nextPage();
    }, 15000);
  },
};
</script>

<style scoped>
.theme {
  color: #9a9899;
  font-size: 2em;
}
</style>
